export enum LoginFormNames {
	login = 'login',
	otpCode = 'otpCode',
	password = 'Password',
	email = 'E-mail address',
}
